export default __webpack_public_path__ + "static/media/pngwing.com.b07c9205.png";